import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ChatIcon from "../../../assets/images/chat_bot.svg";
import ChatWindow from "./ChatWindow";
import { AnimatePresence, motion } from "motion/react";

const ChatbotComponent = () => {
  const chatActionInfo = useSelector((state) => state.chatActionInfo);

  const [isChatWindowVisible, setChatWindowVisible] = useState(false);
  const [intentType, setIntentType] = useState(1);

  useEffect(() => {
    if (chatActionInfo) {
      setIntentType(chatActionInfo?.intentTypes || 1);
      setChatWindowVisible(chatActionInfo?.visibility || false);
    }
  }, [chatActionInfo]);

  const renderChatWindow = (setChatWindowVisible) => {
    return <ChatWindow setChatWindowVisible={setChatWindowVisible} />;
  };

  return (
    <>
      {isChatWindowVisible && (
        <div
          onClick={() => setChatWindowVisible(false)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 4,
            background: "transparent",
          }}
        />
      )}

      <AnimatePresence>
        {isChatWindowVisible ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.7 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            style={{ position: "absolute", bottom: 0,right: 0, zIndex: 5 }}
            key="box"
          >
            {" "}
            <div
              style={{
                position: "absolute",
                zIndex: 5,
                bottom: 8,
                right: 20,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {renderChatWindow(setChatWindowVisible)}
            </div>{" "}
          </motion.div>
        ) : null}
      </AnimatePresence>

      {/* {isChatWindowVisible && (
        <div
          style={{
            position: "absolute",
            zIndex: 5,
            bottom: 100,
            right: 50,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {renderChatWindow()}
        </div>
      )} */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          zIndex: 4,
          right: 20,
          cursor: "pointer",
        }}
        onClick={() => setChatWindowVisible((prev) => !prev)}
      >
        <img src={ChatIcon} alt="Chat" />
      </div>
    </>
  );
};

export default ChatbotComponent;
